import { render } from "./transporterContents.vue?vue&type=template&id=2b48fe10&scoped=true"
import script from "./transporterContents.vue?vue&type=script&lang=js"
export * from "./transporterContents.vue?vue&type=script&lang=js"

import "./transporterContents.vue?vue&type=style&index=0&id=2b48fe10&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b48fe10"]])

export default __exports__